












































































import { Vue, Component } from "vue-property-decorator";
import Spinner from "./components/Spinner.vue";
import config from "./config";

@Component({
  name: "App",
  components: {
    Spinner
  }
})
export default class App extends Vue {
  store = this.$store.direct;

  async mounted() {
    await this.store.dispatch.session.me();
  }

  get validated() {
    return this.store.state.session.user
      ? this.store.state.session.user.attributes.validated
      : false;
  }

  get token() {
    return this.store.state.session.token;
  }

  get admin() {
    return this.store.getters.session.isAdmin;
  }

  get message() {
    return this.store.state.messages.length > 0
      ? this.store.state.messages[0]
      : undefined;
  }

  get snackbar() {
    return this.store.state.messages.length > 0;
  }

  set snackbar(val: boolean) {
    if (!val) {
      this.store.commit.REMOVE_LAST_MESSAGE();
    }
  }

  logout() {
    this.store.state.session.client.getUser().then((user) => {
      this.store.commit.session.LOGOUT();
      if (user) {
        window.location.href = config.logout_redirect_url;
      } else {
        this.$router.push("/");
      }
    })
    
  }

  close(id: string) {
    this.store.commit.REMOVE_MESSAGE(id);
  }
}
